import { BaseExportStrategy } from "./BaseExportStrategy";
import { IExportStrategyConfig } from "./types";

export class MarketplaceExportStrategy extends BaseExportStrategy {
  getConfig(): IExportStrategyConfig {
    return {
      carriersEndpoint: "carriers_clients?getAll=true",
      ordersEndpoint: "orders",
      filesEndpoint: "/orders/files",
      summaryEndpoint: "/orders/summary",
      needsMerchants: true,
      needsAliases: true,
      needsMarketplaceId: true,
      needsClients: false,
    };
  }
}
